import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import { space } from "../../tokens/space";
import { containerWidth } from "../../tokens/size";
const getContainerStyles = (maxWidth) => {
    const applyPaddingWidth = maxWidth + 50;
    return {
        boxSizing: 'border-box',
        width: '100%',
        maxWidth: maxWidth,
        marginInline: 'auto',
        [`@media (max-width: ${applyPaddingWidth}px)`]: {
            paddingLeft: space.containerOuterPadding,
            paddingRight: space.containerOuterPadding,
        },
    };
};
function ContainerComponent({ children, className, maxWidth = containerWidth.md, component, ...other }, ref) {
    const Component = component || 'div';
    const numericMaxWidth = typeof maxWidth === 'string' ? parseInt(maxWidth) : maxWidth;
    return (_jsx(Component, { ref: ref, css: getContainerStyles(numericMaxWidth), className: className, ...other, children: children }));
}
/**
 * A component used to center content with padding and max-width
 */
export const Container = React.forwardRef(ContainerComponent);
